module.exports = __webpack_public_path__ + "img/gift.b2936b2.svg";